module.exports = __webpack_public_path__ + "img/smily.1783fa1f.png";